import React, { useEffect, useRef } from "react";
import { StyledContainer } from "./styles";
import SVG from "react-inlinesvg";
import { DESCRIBE_SENSES } from "../../../../src/shared/constants";
import Toggle from "../Toggle";

function applySenseOverrides(senses, overrides) {
  const updatedSenses = { ...senses };

  Object.entries(overrides).forEach(([sense, enabled]) => {
    if (enabled) {
      updatedSenses[sense] = 1;
    } else {
      delete updatedSenses[sense];
    }
  });

  return updatedSenses;
}

export default function DescribeMenu({
  setDescribeOpen, //
  describeSenses,
  setDescribeSenses,
}) {
  const wrapperRef = useRef(null);
  const localSenseOverridesRef = useRef({});
  const setDescribeSensesRef = useRef(setDescribeSenses);
  setDescribeSensesRef.current = setDescribeSenses;

  const effectiveDescribeSenses = applySenseOverrides(describeSenses, localSenseOverridesRef.current);
  const serverSensesSnapshot = JSON.stringify(Object.entries(describeSenses).sort(([left], [right]) => left.localeCompare(right)));

  useEffect(() => {
    function handleClickOutside(event) {
      event.stopPropagation();

      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDescribeOpen(false);
      }
    }

    // Bind the event listener
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    const serverSenses = Object.fromEntries(JSON.parse(serverSensesSnapshot));
    const overrides = localSenseOverridesRef.current;
    const hasStaleSense = Object.entries(overrides).some(
      ([sense, enabled]) => enabled !== !!serverSenses[sense],
    );

    if (hasStaleSense) {
      setDescribeSensesRef.current(applySenseOverrides(serverSenses, overrides));
    }
  }, [serverSensesSnapshot]);

  return (
    <div ref={wrapperRef}>
      <StyledContainer data-testid="describe-options-menu">
        <ul role="group" aria-label="Describe senses">
          {DESCRIBE_SENSES.map(sense => {
            return <li key={sense.value}>
              <div className="icon">
                <SVG src={sense.image} />
              </div>
              <div className="label">{sense.label}</div>

              <div className="toggle">
                <Toggle
                  aria-label={sense.label}
                  checked={!!effectiveDescribeSenses[sense.value]}
                  set={val => {
                    localSenseOverridesRef.current = {
                      ...localSenseOverridesRef.current,
                      [sense.value]: val,
                    };

                    setDescribeSensesRef.current(
                      applySenseOverrides(describeSenses, localSenseOverridesRef.current),
                    );
                  }}
                />
              </div>
            </li>;
          })}
        </ul>
      </StyledContainer>
    </div>
  );
}
